import { getManageEligibleRule } from "./plan";

const endPoints = {
  home: {
    get: "/api/v1/Home",
    post: "/api/v1/Home",
    getTileCount: "/api/v1/Home/GetTileCount",
  },
  ParticipantAnalytics: {
    participantAnalytics: "api/v1/ParticipantAnalytics",
  },
  communication: {
    postCommunicationCardView: "/api/v1/Communication/CommunicationCardView",
    postSaveCommunication: "/api/v1/Communication/SaveCommunication",
    getSponsorsByPlanOrPlanGroupIds:
      "/api/v1/Communication/GetSponsorsByPlanOrPlanGroupIds",
    getAdminsByPlanOrPlanGroupIds:
      "/api/v1/Communication/GetAdminsByPlanOrPlanGroupIds",
    getEventsList: "/api/v1/Communication/GetEventsList",
    addEmailLayout: "/api/v1/Communication/AddEmailLayout",
    deleteEmailLayout: "/api/v1/Communication/DeleteEmailLayoutById",
    deleteCommunication: "/api/v1/Communication/DeleteCommunicationById",
    getEmailLayout: "/api/v1/Communication/GetEmailLayout",
    getEmailDataById: "/api/v1/Communication/GetEmailDataById",
    getSentCommunicationDetails:
      "/api/v1/Communication/GetSentCommunicationDetails",
    getCommunicationDetailsById:
      "/api/v1/Communication/GetCommunicationDetailsById",
    getSentCommunicationDetailsById:
      "/api/v1/Communication/GetSentCommunicationDetailsById",
    getCommunicationsBasedOnSelectedPlan:
      "/api/v1/Communication/GetCommunicationsBasedOnSelectedPlan",
    getConfiguredCommunicationsBasedOnEvent:
      "/api/v1/Communication/GetConfiguredCommunicationsBasedOnEvent",
    savePlanCommunication: "api/v1/Communication/SavePlanCommunication",
  },
  company: {
    postCompanyGridView: "/api/v1/Company/CompaniesGridView",
    getCompany: "/api/v1/Company/Get",
    postCompany: "/api/v1/Company",
    getGeneratePayrollSchedule: "/api/v1/Company/GeneratePayrollSchedule",
    getNotificationSwitchHistoryForPayDate:
      "/api/v1/Company/GetNotificationSwitchHistoryForPayDate",
    // getCompany: "/api/v1/Company/fetch",
    // postCompany: "/api/v1/Company/save",
    getCompanyNameCheck: "/api/v1/Company/CheckCompanyNameExists",
    getSponsoringOrganisationNameCheck:
      "/api/v1/Plan/checkSponsoringOrganisationExists",
    getSponsoringOrganisationList: "/api/v1/Company/SponsoringOrganisationList",
    postSponsoringOrganisationList:
      "/api/v1/Company/SaveSponsoringOrganisation",
    getCompanyCount: "/api/v1/Company/CompanyCount",
    postSponsoringOrganisations: "/api/v1/Company/SponsoringOrganisations",
    postCompaniesGridViewBySponsoringOrganisation:
      "/api/v1/Company/CompaniesGridViewBySponsoringOrganisation",
    getCheckEinNumberExists: "/api/v1/Company/CheckEinNumberExists",
    getCompanyList: "/api/v1/Company/CompanyName",
    getMasterClassifications: "/api/v1/Company/GetMasterClassificationType",
    addMasterClassifications: "/api/v1/Company/AddMasterClassificationType",
    checkMasterClassificationExists:
      "/api/v1/Company/CheckMasterClassificationExists",
    getMasterEmploymentStatuses: "/api/v1/Company/GetMasterEmploymentStatuses",
    addMasterEmploymentStatus: "/api/v1/Company/AddMasterEmploymentStatus",
    checkMasterEmploymentStatusExists:
      "/api/v1/Company/CheckMasterEmploymentStatusExists",
    getLoanTypes: "/api/v1/Company/GetMasterLoanTypes",
    addMasterLoanType: "/api/v1/Company/AddMasterLoanType",
    uploadCompanyLogo: "/api/v1/Company/AddCompanyLogo",
    getCompanyLogo: "/api/v1/Company/GetCompanyLogo",
    validateClassification: "/api/v1/company/ValidateClassification",
    getRecordKeepers: "api/v1/Company/GetRecordKeepers",
    saveRecordKeepers: "api/v1/Company/SaveRecordKeepers",
    // checkMasterLoanTypeExists: "/api/v1/Company/CheckMasterLoanTypeExists",
  },
  planYos: {
    getPlanYOS: "/api/PlanYOS/GetPlanYOS",
    SavePlanYOS: "/api/PlanYOS/SavePlanYOS",
  },
  plan: {
    getFieldSchema: "/api/v1/Plan/GetFieldSchema",
    getPlanCount: "/api/v1/Plan/PlanCount",
    postPlanGridView: "/api/v1/Plan/PlanGridViewModel",
    getSponsoringOrganisationList: "/api/v1/Plan/SponsorOrganizations",
    postSponsoringOrganisationList: "/api/v1/Plan/SaveSponsorOrganization",
    getPlan: "/api/v1/Plan/Plan",
    postPlan: "/api/v1/Plan/SavePlan",
    checkPlanNameExists: "/api/v1/Plan/CheckPlanNameExists",
    checkRkPlanNumberExists: "/api/v1/Plan/checkRkPlanNumberExists",
    getEmployeeClassifications: "/api/v1/Plan/EmployeeClassifications",
    getPlanList: "/api/v1/Plan/PlanList",
    getSourceList: "/api/v1/Plan/SourceList",
    setPlanStatus: "/api/v1/Plan/UpdatePlanStatus",
    getEmploymentStatusList: "/api/v1/Company/GetEmploymentStatusList",
    getClassificationCodes: "/api/v1/Company/ClassificationCode",
    getCompensationCategories: "/api/v1/Plan/CompensationCategory",
    getIRSLimits: "/api/v1/Plan/IRSLimits",
    getMasterplans: "/api/v1/Plan/MasterPlans",
    getEmployerSourcesList: "/api/v1/Plan/EmployerSourcesList",
    getEmployerSourceListForNonPayPeriod:
      "/api/v1/Plan/EmployerSourcesListForNonPayPeriod",
    getVestingRulesList: "/api/v1/Plan/VestingRulesList",
    getAdoptingEmployerPlan: "/api/v1/Plan/GetAdoptingEmployerPlan",
    getPlanInvestmentData: "/api/v1/Plan/GetPlanInvestmentData",
    GetMasterSourceNames: "/api/v1/Plan/GetMasterSourceNames",
    SaveMasterSourceName: "/api/v1/Plan/SaveMasterSourceName",
    // listAdvisor: "/api/Advisor/ListAdvisor",
    // getAdvisor: "/api/Advisor/GetAdvisor",
    // deleteAdvisor: "/api/Advisor/DeleteAdvisor",
    // saveAdvisor: "/api/Advisor/SaveAdvisor",
    // saveAdvisorToPlan: "/api/Advisor/SaveAdvisorToPlan",

    listAllocation: "/api/Allocation/ListAllocation",
    getAllocation: "/api/Allocation/GetAllocation",
    saveAllocation: "/api/Allocation/SaveAllocation",
    deleteAllocation: "/api/Allocation/DeleteAllocation",

    listBasicPlanDetails: "/api/BasicPlanDetails/ListBasicPlanDetails",
    getBasicPlanDetails: "/api/BasicPlanDetails/GetBasicPlanDetails",
    getReviewAndPlanDetails: "/api/Review/GetReviewAndPlanDetails",
    saveBasicPlanDetails: "/api/BasicPlanDetails/SaveBasicPlanDetails",
    deleteBasicPlanDetails: "/api/BasicPlanDetails/DeleteBasicPlanDetails",

    listCompensation: "/api/Compensation/ListCompensation",
    getCompensation: "/api/Compensation/GetCompensation",
    saveCompensation: "/api/Compensation/SaveCompensation",
    deleteCompensation: "/api/Compensation/DeleteCompensation",

    listCompliance: "/api/Compliance/ListCompliance",
    getCompliance: "/api/Compliance/GetCompliance",
    saveCompliance: "/api/Compliance/SaveCompliance",
    deleteCompliance: "/api/Compliance/DeleteCompliance",

    listCustodian: "/api/Custodian/ListCustodian",
    getCustodian: "/api/Custodian/GetCustodian",
    saveCustodian: "/api/Custodian/SaveCustodian",
    deleteCustodian: "/api/Custodian/DeleteCustodian",

    listEnrollment: "/api/Enrollment/ListEnrollment",
    getEnrollment: "/api/Enrollment/GetEnrollment",
    SaveEnrollmentSetting: "/api/Enrollment/SaveEnrollmentSetting",
    deleteEnrollment: "/api/Enrollment/DeleteEnrollment",

    listEntryDate: "/api/EntryDate/ListEntryDate",
    getEntryDate: "/api/EntryDate/GetEntryDate",
    saveEntryDate: "/api/EntryDate/SaveEntryDate",
    deleteEntryDate: "/api/EntryDate/DeleteEntryDate",

    listForfeiture: "/api/Forfeiture/ListForfeiture",
    getForfeiture: "/api/Forfeiture/GetForfeiture",
    saveForfeiture: "/api/Forfeiture/SaveForfeiture",
    deleteForfeiture: "/api/Forfeiture/DeleteForfeiture",

    listFunding: "/api/Funding/ListFunding",
    getFunding: "/api/Funding/GetFunding",
    saveFunding: "/api/Funding/SaveFunding",
    deleteFunding: "/api/Funding/DeleteFunding",

    listInvestment: "/api/Investment/ListInvestment",
    getInvestment: "/api/Investment/GetInvestment",
    saveInvestment: "/api/Investment/SaveInvestment",
    deleteInvestment: "/api/Investment/DeleteInvestment",
    addInvestmentsToPlan: "/api/Investment/AddInvestmentsToPlan",

    listLoan: "/api/Loan/ListLoan",
    getLoan: "/api/Loan/GetLoan",
    saveLoan: "/api/Loan/SaveLoan",
    deleteLoan: "/api/Loan/DeleteLoan",

    listRetirement: "/api/Retirement/ListRetirement",
    getRetirement: "/api/Retirement/GetRetirement",
    saveRetirement: "/api/Retirement/SaveRetirement",
    deleteRetirement: "/api/Retirement/DeleteRetirement",

    listRollover: "/api/Rollover/ListRollover",
    getRollover: "/api/Rollover/GetRollover",
    saveRollover: "/api/Rollover/SaveRollover",
    deleteRollover: "/api/Rollover/DeleteRollover",

    listSource: "/api/Source/ListSource",
    getSource: "/api/Source/GetSource",
    saveSource: "/api/Source/SaveSource",
    deleteSource: "/api/Source/DeleteSource",

    listSponsor: "/api/Sponsor/ListSponsor",
    getSponsor: "/api/Sponsor/GetSponsor",
    saveSponsor: "/api/Sponsor/SaveSponsor",
    deleteSponsor: "/api/Sponsor/DeleteSponsor",

    listTransfer: "/api/Transfer/ListTransfer",
    getTransfer: "/api/Transfer/GetTransfer",
    saveTransfer: "/api/Transfer/SaveTransfer",
    deleteTransfer: "/api/Transfer/DeleteTransfer",

    listTrustee: "/api/Trustee/ListTrustee",
    getTrustee: "/api/Trustee/GetTrustee",
    saveTrustee: "/api/Trustee/SaveTrustee",
    deleteTrustee: "/api/Trustee/DeleteTrustee",
    saveTrusteeToPlan: "/api/Trustee/SaveTrusteeToPlan",

    listVesting: "/api/Vesting/ListVesting",
    getVesting: "/api/Vesting/GetVesting",
    saveVesting: "/api/Vesting/SaveVesting",
    deleteVesting: "/api/Vesting/DeleteVesting",
    deleteAdditionalVesting: "/api/Vesting/DeleteAdditionalVesting",

    listWithdrawal: "/api/Withdrawal/ListWithdrawal",
    getWithdrawal: "/api/Withdrawal/GetWithdrawal",
    saveWithdrawal: "/api/Withdrawal/SaveWithdrawal",
    deleteWithdrawal: "/api/Withdrawal/DeleteWithdrawal",

    savePlanEligibility: "/api/v1/EligibleRule/SaveEligibleRule",
    savePlanAmendment: "/api/v1/EligibleRule/SavePlanAmendmentEligibleRule",
    getPlanEligibility: "/api/v1/EligibleRule/GetEligibleRule",
    deletePlanEligibility: "/api/v1/EligibleRule/DeleteEligibleRule",
    deletePlanAmendment: "/api/v1/EligibleRule/DeletePlanAmendment",
    getManageEligibleRule: "/api/v1/EligibleRule/GetManageEligibleRule",
    listEligibleRule: "/api/v1/EligibleRule/ListEligibleRule",
    getPlanEligibleMasterLTPTData:
      "/api/v1/EligibleRule/GetPlanEligibleMasterLTPTData",
    getSourcesListForVesting: "/api/v1/Plan/GetSourcesListForVesting",

    getAllClearingPartners: "/api/ClearingPartner/GetClearingPartners",
    getClearingPartner: "/api/ClearingPartner/GetClearingPartner",
    addClearingPartnerToPlan:
      "/api/ClearingPartner/UpsertPlanWithClearingPartnerAccount",
    getPlanAssociatedClearingPartners:
      "api/ClearingPartner/GetPlanAssociatedClearingPartnerAccounts",
    getInvestmentAssociatedClearingPartner:
      "/api/ClearingPartner/GetInvestmentAssociatedClearingPartnerAccounts",
    saveInvestmentAssociatedClearingPartner:
      "/api/ClearingPartner/UpsertInvestmentWithClearingPartnerAccount",
    upsertClearingPartner: "/api/ClearingPartner/UpsertClearingPartnerAccount",
    deleteClearingPartner: "/api/ClearingPartner/DeleteClearingPartnerAccount",
    getClearingPartnerPlans:
      "/api/ClearingPartner/GetClearingPartnerAssociatedPlan",
    getClearingPartnerAccountPlans:
      "/api/ClearingPartner/GetClearingPartnerAccountAssociatedPlan",
    upsertClearanceTime: "/api/ClearingPartner/UpsertClearanceTime",
    deleteClearanceTime: "/api/ClearingPartner/DeleteClearanceTime",

    getAllMasterAdvisors: "/api/Advisor/ListAdvisor",
    getAdvisor: "/api/Advisor/GetAdvisor",
    upsertAdvisorRepresentative: "/api/Advisor/UpsertAdvisorRepresentative",
    upsertAdvisorToPlan: "/api/Advisor/UpsertAdvisorRepresentativeToPlan",
    getAdvisorRepresentativePlans:
      "/api/Advisor/GetAdvisorRepresentativeAssociatedPlans",
    getAdvisoPlans: "/api/Advisor/GetAdvisorAssociatedPlans",
    getPlansAssociatedWithAdvisorRepresentative:
      "/api/Advisor/GetPlansAssociatedWithAdvisorRepresentative",
    getInvestmentAssociatedAdvisorRepresentative:
      "/api/Advisor/GetInvestmentAssociatedAdvisorRepresentative",
    upsertAdvisorRepresentativeToInvestment:
      "/api/Advisor/UpsertAdvisorRepresentativePlanMappingToInvestment",
    deleteAdvisorRepresentative: "/api/Advisor/DeleteAdvisorRepresentative",
  },

  masterData: {
    getCustodians: "/api/v1/MasterData/Custodians",
    getAdvisors: "/api/v1/MasterData/Advisors",
    getTrustees: "/api/v1/MasterData/Trustees",
    getSources: "/api/v1/MasterData/Sources",
    getInvestments: "/api/v1/MasterData/Investments",
  },
  refData: {
    getStates: "/api/v1/State",
  },
  payroll: {
    exportOutputFiles: "/api/v1/Payroll/ExportOutputFiles",
    downloadpreviewfile: "/api/v1/Payroll/DownloadPreviewFile",
    getEmployeeCount: "/api/v1/Payroll/GetEmployeeCount",
    getPlanCount: "/api/v1/Payroll/GetPlanCount",
    getCompanyCount: "/api/v1/Payroll/GetCompanyCount",
    finalSubmit: "/api/v1/Payroll/FinalSubmit",
    finalSubmitAndFunding: "/api/v1/Payroll/FinalSubmitAndFunding",
    saveFundingDetails: "/api/v1/Payroll/SaveFundingDetails",
    saveFundingDetailsByFile: "/api/v1/Payroll/SaveFundingDetailsByFile",
    saveFundingDetailsByPlan: "/api/v1/Payroll/SaveFundingDetailsByPlan",
    saveFundingByClassificationDetails:
      "/api/v1/Payroll/SaveFundingByClassificationDetails",
    getAwaitingFundingDetailsByPlan:
      "/api/v1/Payroll/GetAwaitingFundingDetailsByPlan",
    getAwaitingFundingDetailsByClassification:
      "/api/v1/Payroll/GetAwaitingFundingDetailsByClassification",
    confirmFunds: "/api/v1/Payroll/ConfirmFunds",
    getClassificationDetailsByFileId:
      "/api/v1/Payroll/GetClassificationDetailsByFileId",
    submitAndUpdateTempEmployeeInECR: "/api/v1/Payroll/ECRSubmitAndUpdate",
    addEmployeeToPayroll: "​/api​/v1​/Payroll​/AddEmployeeForPayroll​",
    deleteTempEmployeeId: "/api/v1/Payroll/DeleteTempEmployeeById",
    getFilesBasedOnSearch:
      "/api/v1/Payroll/GetUploadedFilesBasedOnSearchCriteria",
    geFileInformationById: "/api/v1/Payroll/GetFileInformation",
    getFileGraphInformation: "/api/v1/Payroll/FileProgressGraphInformation",
    getPayrollMetaDataInfo: "/api/v1/Payroll/GetPayrollMetaDataInformation",
    getPayrollEmployeeDetails: "/api/v1/Payroll/GetPayrollDetails",
    retrievePayrollDetailsByFileId:
      "/api/v1/Payroll/RetrievePayrollDetailsByFileId",
    getFundingDetailsByFile: "/api/v1/Payroll/GetFundingDetailsByFile",
    getFundingDetailsByClassification:
      "/api/v1/Payroll/GetFundingDetailsByClassification",
    getFundingDetailByPlan: "/api/v1/Payroll/GetFundingDetailByPlan",
    getFundingDetailByDivision: "/api/v1/Payroll/GetFundingDetailByDivision",
    getFundingTransactionDetailsByClassification:
      "/api/v1/Payroll/GetFundingTransactionDetailsByClassification",
    getCustodianBankDetails: "/api/v1/Payroll/GetCustodianBankDetails",
    getFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage:
      "/api/v1/Payroll/GetFundingTransactionDetailsOfEmployeeInPayrollSubmissionPage",
    getForfeitureDetails: "/api/v1/Payroll/GetForfeitureDetails",
    recordLock: "/api/v1/Payroll/RecordLock",
    getSourceDeferral: "/api/v1/Payroll/GetSourceDeferral",
    getAllEmployeeLoans: "/api/v1/Payroll/GetAllEmployeeLoans",
    acceptAllWarningsInaFile: "/api/v1/Payroll/AcceptAllWarningsInaFile",
    acceptWarningsByMessage: "/api/v1/Payroll/AcceptWarningsById",
    createPayroll: "/api/v1/Payroll/CreatePayroll",
    GetErrorList: "/api/v1/payroll/ErrorList",
    GetWarningsList: "/api/v1/payroll/WarningsList",
    getAllRecordsList: "/api/v1/payroll/GetAllRecordsList",
    getTempEmployeeDetailsByssn:
      "​/api​/v1​/Payroll​/GetPayrollInformationBySSN​",
    getTempEmployeeDetailsById: "/api/v1/payroll/TempEmployeeDetailsById​",
    getFileInformationById: "/api/v1/Payroll/GetFileInformation",
    getDataTypeMisMatches: "/api/v1/Payroll/GetDataTypeMisMatchErrors",
    getDuplicateEmployeeByFileId: "/api/v1/Payroll/GetDuplicateEmployeeSSN",
    getDuplicateRecord: "/api/v1/Payroll/GetDuplicateRecordDetails",
    getCorrectAcceptDuplicateEmployee:
      "/api/v1/Payroll/CorrectAcceptDuplicateEmployee",
    getFilesBySearchCriteria: "/api/v1/Payroll/GetFilesBySearchCriteria",
    getFundingTransactionDetailsByPlan:
      "/api/v1/Payroll/GetFundingTransactionDetailsByPlan",
    retrieveBankDetails: "/api/v1/Payroll/RetreiveBankDetails",
    getEmployeeDetailsbycompanyandplan:
      "/api/v1/Payroll/GetEmployeeByCompanyName",
    removeEmployeeFromPayroll:
      "/api/v1/Payroll/DeleteTempEmployeeDuringCreatePayroll",
    getTempEmployeeDetails: "/api/v1/Payroll/GetTempEmployeeDetailsById",
    getEmpCensusInformation: "/api/v1/Payroll/GetEmployeeCensusInformation",
    recordUnlock: "/api/v1/Payroll/RecordUnlock",
    errorAndWarningMetadata: "/api/v1/Payroll/GetErrorAndWarningMetadata",
    payrollAndCensusFileUpload: "/api/v1/Payroll/PayrollAndCensusFileUpload",
    TempMappingFileUpload: "/api/v1/Payroll/TempMappingFileUpload",
    deleteFileById: "/api/v1/Payroll/DeleteFileById",
    deleteCensusFileById: "/api/v1/Payroll/DeleteCensusFileById",
    getWarningsForECR: "/api/v1/Payroll/WarningsList",
    getRevalidateFile: "/api/v1/Payroll/RevalidateFile",
    checkClassificationTypePresent: "/api/v1/Payroll/ClassificationTypeExists",
    GetTempCreatePayroll: "/api/v1/Payroll/GetTempCreatePayroll",
    getCompanyPlanPayrollFrequencies:
      "/api/v1/Payroll/GetCompanyPlanPayrollFrequencies",
    createPayrollFromUI: "/api/v1/Payroll/CreatePayrollFromUI",
    getPayrollEmployeesSSNAndNameByFileId:
      "/api/v1/Payroll/GetPayrollEmployeesSSNAndNameByFileId",
    getCreatePayrollInformationByFileId:
      "/api/v1/Payroll/GetCreatePayrollInformationByFileId",
    getEmployerSources: "/api/v1/Payroll/GetEmployerSources",
    getComputationalPeriods: "/api/v1/Payroll/GetComputationalPeriods",
    downloadCreatePayrolldetail: "/api/v1/Payroll/downloadCreatePayrolldetail",
    submitCreatePayroll: "/api/v1/Payroll/submitCreatePayroll",
    UpdatePayrollEmployee: "/api/v1/Payroll/UpdatePayrollEmployee",
    acceptAllDataChangeValidationInaFile:
      "/api/v1/Payroll/AcceptDataChangeValidationInaFile",
    acceptEmployeeWarnings: "/api/v1/Payroll/AcceptEmployeeWarnings",
    saveEligibilityInformation: "/api/v1/Payroll/SaveEligibilityInformation",
    getDownloadUploadedFileReport: "/api/v1/Payroll/DownloadUploadedFile",

    getDownloadSubmittedFileReport: "/api/v1/Payroll/DownloadSubmittedFile",
    getRecordDetailsInGetWarningScreen:
      "/api/v1/Payroll/GetRecordDetailsInGetWarningScreen",
    getFileUploadCount: "/api/v1/Payroll/GetFileUploadCount",
    getForfeitureSummaryDetails: "/api/v1/Payroll/GetForfeitureSummaryDetails",
    getForfeitureSourceHistoryTransactions:
      "/api/v1/Payroll/GetSourceHistoryDetails",
    getCountsForErrorReportTabs: "/api/v1/Payroll/GetCountsForErrorReportTab",
    AddBeneficary: "/api/v1/Payroll/AddBeneficary",
    getDownloadPayrollReport: "/api/v1/Payroll/ExportPayrollSummaryReport",
    OutputFileRegenerate: "api/v1/Payroll/OutputFileRegenerate",
  },
  census: {
    getEmployeeClassificationHistory:
      "/api/v1/Payroll/GetEmployeeclassificatonHistory",
    getEmployeeCompensation: "/api/v1/Payroll/GetEmployeeCompensation",
    getSourceLevelContribution: "/api/v1/Payroll/GetSourceLevelContribution",
    getSourceDeferral: "/api/v1/Payroll/GetSourceDeferral",
    getAllEmployeeLoans: "/api/v1/Payroll/GetAllEmployeeLoans",
    getEnrolledPlans: "/api/v1/Payroll/GetEnrolledPlans",
    getEligibilityInformation: "/api/v1/Payroll/GetEligibilityInformation",
    getEligibilitySummaryReport: "/api/v1/Eligibility/EligibilitySummaryReport",
    getEligibilityDetailReport: "/api/v1/Eligibility/EligibilityDetailReport",
    getEligibilityHistory: "/api/v1/Payroll/GetEligibilityHistory",
    getEmployeesBySearchCriteria:
      "/api/v1/Payroll/GetEmployeesBySearchCriteria",
    addEmployeeContribution: "/api/v1/Payroll/AddEmployeeContribution",
    addEmployeeCompensation: "/api/v1/Payroll/AddEmployeeCompensation",
    addHoursDetail: "/api/v1/Payroll/AddHoursDetail",
    getEmployeeContribution: "/api/v1/Payroll/GetEmployeeContribution",
    getCensusHistory: "/api/v1/Payroll/GetEmployeeHistoryDetails",
    deleteExistingEmployee: "/api/v1/Payroll/DeleteExistingEmployeeById",
    getEmployeeLoanRepayments: "/api/v1/Payroll/GetLoanRepaymentInformation",
    getPlanMetaData: "/api/v1/Payroll/GetPlanMetaData",
    getHoursDetails: "/api/v1/Payroll/GetHoursDetail",
    saveEmployeeToPayroll: "/api/v1/Payroll/SaveEmployee",
    updateEmployeeToPayroll: "/api/v1/Payroll/UpdateExistingEmployee",
    getEmployee: "/api/v1/Payroll/GetEmployee",
    getClassificationDetailsByFileId:
      "/api/v1/Payroll/GetClassificationDetailsByFileId",
    getEmployeeClassificationType: "/api/v1/company/classificationType",
    getEmployeeClassificationName: "/api/v1/company/getClassifications",
    getEmployeeRehireDetails: "/api/v1/Payroll/GetEmployeeRehireDetails",
    getEmployeePlanSources: "/api/v1/Plan/SourceList",
    getEmploymentStatusList: "/api/v1/Company/GetEmploymentStatusList",
    getPayrollFrequencies: "/api/v1/Payroll/GetPayrollFrequencies",
    getCountiesList: "/api/v1/Country",
    getStatesList: "/api/v1/State",
    uploadEmployeeLogo: "/api/v1/Payroll/UploadEmployeeLogo",
    getEmployeeImage: "/api/v1/Payroll/GetEmployeeLogo",
    getBeneficiaryDetailsByEmployeeId:
      "/api/v1/Payroll/GetBeneficiaryDetailsByEmployeeId",
    getBeneficiaryDetailsById: "/api/v1/Payroll/GetBeneficiaryDetailsById",
    getPlanDetailsByEmployeeId: "/api/v1/Payroll/GetPlanDetailsByEmployeeId",
    getSourceAndInvestmentDetailsAgainstSourceByPlanId:
      "/api/RolloverIn/GetSourceAndInvestmentDetailsAgaintSourceByPlanId",
    editBeneficiaryPercentage: "/api/v1/Payroll/editBeneficiaryPercentage",
  },
  eligibility: {
    runEligibility: "/api/v1/Eligibility/RunManualEligibility",
  },
  enrollment: {
    getPlanSourceInformation:
      "/api/v1/Enrollment/RetrievePlanSourceInformation",
    getPlanInvestments: "api/v1/Enrollment/GetPlanInvestments",
    postDefaultElectionSetting: "/api/v1/Enrollment/SaveDefaultElectionSetting",
    postPlanInvestment: "/api/v1/Enrollment/AddPlanInvestment",
    postADIApplicableConfiguration:
      "/api/v1/Enrollment/SaveADIApplicableConfiguration",
    getDefaultElectionSetting:
      "/api/v1/Enrollment/GetDefaultElectionSettingIfExists",
    deleteInvestment: "/api/v1/Enrollment/DeleteInvestment",
    getADIApplicableConfiguration: "/api/v1/Enrollment/RetrieveADIDataIfExists",
    saveAutoEnrollment: "/api/v1/Enrollment/SaveAutoEnrollment",
    getAutoEnrollment: "/api/v1/Enrollment/GetAutoEnrollment",
    getEmployeeClassification:
      "/api/Enrollment/GetEmployeeClassificationAndEmploymentStatus",
    saveAdditionalAutoEnrollment:
      "/api/v1/Enrollment/SaveAdditionalAutoEnrollment",
    retrieveAdditionalAutoEnrollmentIfExists:
      "/api/v1/Enrollment/RetrieveAdditionalAutoEnrollmentIfExists",
    AutoEnrollmentGeneration: "/api/v1/Enrollment/AutoEnrollmentGeneration",
    EnrollmentSummaryReport: "/api/v1/Enrollment/EnrollmentSummaryReport",
    ParticipantwiseReport: "/api/v1/Enrollment/ParticipantwiseReport",
    CompanyanddPlanWiseEnrollmentReport:
      "/api/v1/Enrollment/CompanyanddPlanWiseEnrollmentReport",
    GetEnrollment: "/api/v1/Enrollment/GetEnrollment",
    SaveEnrollment: "/api/v1/Enrollment/SaveEnrollment",
    OptOutPlan: "/api/v1/Enrollment/OptOutPlan",
  },
  maintenance: {
    getHolidayCalendarMaster: "/api/v1/Maintenance/GetHolidays",
    saveHolidayDetails: "/api/v1/Maintenance/AddHolidays",
    deleteHoliday: "/api/v1/Maintenance/DeleteHoliday",
    getPlanGroups: "/api/v1/Maintenance/GetPlanGroups",
    getPlanGroupsWithoutCount: "/api/v1/Maintenance/getPlanGroupsWithoutCount",
    getAdvisors: "/api/v1/Maintenance/GetAdvisors",
    getCustodians: "/api/v1/Maintenance/GetCustodians",
    getInvestments: "/api/v1/Maintenance/GetInvestmentNames",
    getTrustees: "/api/v1/Maintenance/GetTrustees",
    getPlansInPlanGroup: "/api/v1/Maintenance/GetPlansBySearchCriteria",
    deletePlanGroup: "/api/v1/Maintenance/DeletePlanGroup",
    getPlansBySearchCriteria: "/api/v1/Maintenance/GetPlansBySearchCriteria",
    addPlanGroup: "/api/v1/Maintenance/AddPlanGroup",
    getPlanGroupById: "/api/v1/Maintenance/GetPlanGroupById",
    getPayrollScheduleExtension: "/api/v1/Maintenance/PayrollScheduleExtension",
    getPayrollscheduleException:
      "/api/v1/Maintenance/GetPayrollScheduleExceptionReport",
    updateSchedulePayDate: "/api/v1/Maintenance/UpdateSchedulePayDate",
    downloadPayrollScheduleException:
      "/api/v1/Maintenance/DownloadScheduleExceptionReport",
  },
  reports: {
    getSponsorOrganizationList: "/api/v1/Report/GetSponsorOrganizationList",
    getMasterPlanList:
      "/api/v1/Report/GetMasterPlanListBySponsorOrganizationId",
    getFileInformationWithErrorDetailsById: "/api/v1/Report/GetFileInformation",
    getAllEmployeeRecords: "/api/v1/Report/GetAllFileEmployeeReport",
    getEmployeeTransactionDetails:
      "/api/v1/Report/GetEmployeePayDateLevelTransactionDetails",
    getSourceLevelPayrollDetailsById:
      "/api/v1/Report/GetSourceLevelPayrollinformation",
    getDataChangeInformation: "/api/v1/Report/GetDataChangeReportInformation",
    getDataOverrideInformation:
      "/api/v1/Report/GetDataOverrideReportInformation",
    getErrorValidationInformation:
      "/api/v1/Report/GetErrorValidationInformation",
    getPayrollFundingInformation: "/api/v1/Report/GetPayrollFundingInformation",
    getDownloadDataChangeReport: "/api/v1/Report/DownloadDataChangeReport",
    getDownloadDataOverrideReport: "/api/v1/Report/DownloadDataOverrideReport",
    getDownloadErrorValidationReport: "/api/v1/Report/DownloadErrorReport",
    getDownloadFundingReport:
      "/api/v1/Report/DownloadPayrollFundingInformation",
    getDownloadUploadedFileReport: "/api/v1/Report/DownloadInputFile",
    getDownloadSubmittedFileReport: "/api/v1/Report/DownloadSubmittedFile",
    getDownloadPlanEligibilityDataReport:
      "/api/v1/Report/DownloadPlanEligibilityReport",
    getDownloadPayrollWorkloadAnticipationReport:
      "/api/v1/Report/DownloadPayrollWorkloadAnticipationReport",
    getDownloadPlanListReport: "/api/v1/Report/DownloadPlanListReport",
    getDownloadAllFileEmployeeDetails:
      "/api/v1/Report/DownloadAllFileEmployeeDetails",
    // Manage Report
    getCompaniesList: "/api/v1/Report/GetCompaniesList",
    getNonPayPeriodReportData: "/api/v1/Report/GetNonPayPeriodReportdata",
    downloadReportNonPayPeriod: "/api/v1/Report/DownloadReportNonPayPeriod",
    getMasterLoanTypes: "/api/v1/Report/GetMasterLoanTypes",
    getPlansList: "/api/v1/Report/GetPlansList",
    getDownloadEligibilityStatusReport:
      "/api/v1/Report/DownloadEligibilityStatusReport",
    getEligibilityStatusReportInformation:
      "/api/v1/Report/GetEligibilityStatusReportInformation",
    getReportStatusForNonPayPeriod:
      "api/v1/Report/GetReportStatusForNonPayPeriod",
    getDownloadEligibilityForecastReport:
      "/api/v1/Report/DownloadEligibilityForcastReport",
    getEligibilityForecastReportInformation:
      "/api/v1/Report/GetEligibilityForecastReportInformation",
    getDownload402gReport: "/api/v1/Report/Download402GReport",
    get402gReportInformation: "/api/v1/Report/Get402gContribitionReport",
    getForfeitureSummaryReport: "/api/v1/Report/GetForfeitureSummaryReport",
    getDownloadContributionDataReport:
      "/api/v1/Report/DownloadContributionDataReport",
    getContributionDataReportInfo:
      "/api/v1/Report/GetParticipantContributionDataReport",
    getDownloadParticipantUpdatesReport:
      "/api/v1/Report/DownloadParticipantUpdateReport",
    getParticipantUpdatesReportInfo:
      "/api/v1/Report/GetParticipantUpdateReport",
    getContributionFlagsReportInfo: "/api/v1/Report/GetContributionFlagsReport",
    getDownloadContributionFlagsReport:
      "/api/v1/Report/DownloadContributionFlagsReport",
    getDownload415Report: "/api/v1/Report/Download415Report",
    getDownloadLoanRepaymentReport: "api/v1/report/DownloadLoanRepaymentReport",
    get415ReportInformation: "/api/v1/Report/Get415ContribitionReport",
    getLoanRepaymentReport: "/api/v1/Report/GetLoanRepaymentReport",
    getDownloadDeletedParticipantReport:
      "/api/v1/Report/DownloadDeletedParticipantReport",
    getDeletedParticipantReportInformation:
      "/api/v1/Report/GetDeletedParticipantReport",
    getRehireParticipantsReportInformation:
      "/api/v1/Report/GetRehireParticipantsReport",
    getCompensationHoursLoansReportInformation:
      "/api/v1/Report/GetCompensationHoursLoans",
    downloadCompensationHoursLoansReportInformation:
      "/api/v1/Report/DownloadCompensationHoursLoans",
    getNewParticipantEligibilityReportInformation:
      "/api/v1/Report/GetNewParticipantEligibilityReport",
    getDownloadEmploymentStatusReport:
      "/api/v1/Report/DownloadEmploymentStatusReport",
    getVestingReductionReport: "/api/v1/Report/VestingReductionReport",
    getVestingParticipantStatusChange:
      "/api/v1/Report/VestingParticipantStatusChange",
    getEmploymentStatusReportInformation:
      "/api/v1/Report/GetEmployementStatusReport",
    getDownloadNewParticipantReport:
      "/api/v1/Report/DownloadNewParticipantsReport",
    getDownloadRehireReport: "/api/v1/Report/DownloadRehireParticipantsReport",
    getDownloadErrorCountReport: "/api/v1/Report/DownloadErrorCountReport",
    getErrorCountReportInformation:
      "/api/v1/Report/GetErrorCountReportInformation",
    getSponsorDetailsReportInformation:
      "/api/v1/Report/GetSponsorDetailsReport",
    getDownloadSponsorDetailsReport:
      "/api/v1/Report/DownloadSponsorDetailsReport",
    getPlanSummaryReportInformation: "/api/v1/Report/GetPlanSummaryReport",
    getDownloadPlanSummaryReport: "/api/v1/Report/DownloadPlanSummaryReport",
    getDownloadLatePayrollNotificationsReport:
      "/api/v1/Report/DownloadLatePayrollNotificationReport",
    getLatePayrollNotificationsReportInformation:
      "/api/v1/Report/GetLatePayrollNotificationReport",
    getPayrollCancellation: "/api/v1/Payroll/PayrollCancellation",
    getDownloadPeriodicCensusReport:
      "/api/v1/Report/DownloadPeriodicCensusReport",
    getPeriodicCensusReport: "/api/v1/Report/GetPeriodicCensusReport",
    getDownloadPeriodicEmployerContributionReport:
      "/api/v1/Report/DownloadPeriodicEmployerContributionReport",
    getPeriodicEmployerContributionReport:
      "/api/v1/Report/GetPeriodicEmployerContributionReport",
    generatePeriodicEmployerContributionPayrollFile:
      "/api/v1/Report/DownloadPeriodicEmployerContributionPayrollFile",
    getRMDReport: "/api/v1/Report/GetRMDReport",
    getMissedRMDReport: "/api/v1/Report/DownloadMissedRMDReport",
    getDownloadRMDReport: "/api/v1/Report/GetDownloadRMDReport",
    getForceOutReportInformation: "/api/v1/Report/GetForceOutReport",
    getDownloadForceOutReport: "/api/v1/Report/GetDownloadForceOutReport",
    getDownloadAggregatedReport:
      "/api/v1/Report/DownloadAggregatedPeriodicReport",
    getLoanRepaymentDetailReport: "/api/v1/Report/GetLoanRepaymentDetailReport",
    getDownloadLoanRepaymentDetailReport:
      "/api/v1/Report/GetDownloadLoanRepaymentDetailReport",
    getFileUploadedReport: "/api/v1/Report/GetFileUploadedReport",
    getTopErrorCodes: "/api/v1/Report/GetTopErrorCodes",
    getEmployeeTransactionReport: "/api/v1/Report/GetEmployeeTransactionReport",
    getPlanTransactionReport: "/api/v1/Report/GetPlanTransactionReport",
    getMapperTransactionReport: "/api/v1/Report/GetMapperTransactionReport",
    getEnrollmentReviewReport: "/api/v1/Report/GetEnrollmentReviewReport",
    downloadEnrollmentReviewReport:
      "/api/v1/Report/DownloadEnrollmentReviewReport",
    get316ReportInfo: "/api/v1/Report/Get316CensusReport",
    download316ReportInfo: "/api/v1/Report/Download316CensusReport",
    downloadPayrollCalendarEndDateReport:
      "/api/v1/Report/DownloadPayrollCalendarEndDateReport",
    getDownloadMapperListReport: "/api/v1/Report/DownloadMapperListReport",
    downloadNonPayPeriodReport: "/api/v1/Report/DownloadNonPayPeriodReport",
    getDownloadPayrollFrequencyReport: "/api/v1/Report/DownloadPayrollFrequencyReport",
  },
  ai: {
    getMappings: "/api/v1/AI/GetMappings",
    getTextToSql: "/api/v1/AI/GetTextToSql",
  },
  mapper: {
    getMappingProfiles: "/api/Mapping",
    searchProfiles: "/api/Mapping/SearchProfiles",
    getProfileData: "/api/Mapping",
    getProfiles: "/api/Mapping/GetProfiles",
    getInputProfiles: "/api/Mapping/GetInputProfiles",
    getOutputProfiles: "/api/OutputProfile/GetOutPutProfiles",
    //getOutputProfiles: "/api/Mapping/GetOutputProfiles",
    getTargetDetails: "/api/Mapping/GetTargetDetails",
    getTargetModelValues: "/api/Mapping/GetTargetModelValues",
    getOutputProfileName: "/api/OutputProfile/GetOutPutProfilesName",
    verifyMapService: "/api/Mapping/VerfiyObjectMap",
    saveOnProfileCreate: "/api/Mapping/SaveOnProfileCreate",
    SaveOnTempMappingProfileCreate:
      "/api/Mapping/SaveOnTempMappingProfileCreate",
    SaveBasicInformation: "/api/Mapping/SaveBasicInformation",
    deleteInputPlanGroupOutputById:
      "/api/Mapping/DeleteInputPlanGroupOutputById",
    cloneProfile: "/api/Mapping/CloneProfile",
    UpdateStatus: "/api/Mapping/UpdateStatus",
    mappingChange: "/api/Mapping/SaveOnMappingChange",
    profileNameChange: "/api/Mapping/UpdateProfileName",
    getActivePlans: "/api/Mapping/GetFilteredPlans",
    onAggregateSave: "/api/Mapping/SaveOnDeDupChange",
    onFilterSave: "/api/Mapping/SaveOnFilter",
    updatePlans: "/api/Mapping/UpdatePlans",
    updateInputPlanGroups: "/api/Mapping/UpdateInputPlanGroups",
    saveTargetType: "/api/Mapping/SaveTargetType",
    onSchedulerSave: "/api/Mapping/SaveOnChannelChange",
    checkProfileNameExists: "/api/Mapping/CheckProfileNameExists",
    onFixedLengthFileCreate: "/api/Mapping/SaveOnFixedWidth",
    deleteMappingProfile: "/api/Mapping",
    saveProfileFromYaml: "/api/Mapping/SaveProfileFromYaml",
    downloadProfileAsYaml: "/api/Mapping/DownloadProfileAsYaml",

    //output mapper
    saveOutputTarget: "/api/OutputProfile/SaveOutputTarget",
    deleteOutputProfile: "/api/OutputProfile/DeleteOutputProfile",
    validateOutputProfile: "/api/OutputProfile/ValidateOutputProfile",
    cloneOutputProfile: "/api/OutputProfile/CloneOutputProfile",
    downloadSampleFixedWidthFile:
      "/api/OutputProfile/DownloadSampleFixedWidthFile",
    onOutputFilterSave: "/api/OutputProfile/SaveOnFilter",
    saveMapAndTransformOutput: "/api/OutputProfile/SaveMapAndTransformOutput",
    fixedWidthOutputMappingSave:
      "/api/OutputProfile/FixedWidthOutputMappingSave",
    DeletePlanGroupOutputById: "/api/OutputProfile/DeletePlanGroupOutputById",
    outputSaveBasicInformation: "/api/OutputProfile/SaveBasicInformation",
    getOutputProfileData: "/api/OutputProfile",
    updatePlanGroups: "/api/OutputProfile/UpdatePlanGroups",
    updateOutputPlans: "/api/OutputProfile/UpdateOutputPlans",

    //passthrough
    passthroughSaveBasicInformation: "/api/Passthrough/SaveBasicInformation",
    getPassthroughProfileData: "/api/Passthrough",
    saveOnSourceProfileCreate: "/api/Passthrough/SaveOnSourceProfileCreate",
    saveOnTargetProfileCreate: "/api/Passthrough/SaveOnTargetProfileCreate",
    savePassthroughTarget: "/api/Passthrough/SavePassthroughTarget",
    savePreview: "/api/Passthrough/SavePreview",
    saveSplit: "/api/Passthrough/SaveSplit",
    savePassthroughMapAndTransform:
      "/api/Passthrough/SavePassthroughMapAndTransform",
    onPassthroughFilterSave: "/api/Passthrough/SaveOnPassthroughFilter",
    saveValidation: "/api/Passthrough/SaveValidation",
    getValidationRules: "/api/Passthrough/getValidationRules",
    saveOnPassthroughAggregate: "/api/Passthrough/SaveOnPassthroughAggregate",
  },
  master: {
    getTradingPartner: "/api/v1/Report/GetTradingPartner",
    getTradingPartnerList: "/api/v1/Report/GetTradingPartnerList",
    deleteClearingPartner: "/api/v1/Report/DeleteClearingPartner",
    addClearingPartnerAccountsToPlan:
      "/api/v1/Report/AddClearingPartnerAccountsToPlan",
  },
  outputFiles: {
    getOutputFiles: "/api/v1/OutputFile/GetOutputFiles",
    getDownloadSubmittedFile: "/api/v1/OutputFile/DownloadSubmittedFile",
  },
  mappingTemplates: {
    post: "/api/v1/GenerateProfile/Post",
    createRule: "/api/v1/GenerateProfile/CreateRule",
    createSettings: "/api/v1/GenerateProfile/CreateSettings",
    generateOutputProfile: "/api/v1/GenerateProfile/GenerateOutputProfile",
  },
  trade: {
    addMasterInvestment: "/api/v1/Investment/AddMasterInvestment",
    getMasterInvestmentBySearchCriteria:
      "/api/v1/Investment/GetMasterInvestmentBySearchCriteria",
    getCompetingFunds: "/api/v1/Investment/GetCompetingFunds",
    getApplicableInvestments: "/api/v1/Investment/GetApplicableInvestments",
    getInvestment: "/api/v1/Investment/GetInvestment",
    deleteMasterInvestmentById: "/api/v1/Investment/DeleteMasterInvestmentById",
    getInvestmentType: "/api/v1/Tenant/GetMasterInvestmentType",
    getInvestmentCategory: "/api/v1/Tenant/GetMasterInvestmentCategory",
    addInvestmentType: "/api/v1/Tenant/AddMasterInvestmentType",
    addInvestmentCategory: "/api/v1/Tenant/AddMasterInvestmentCategory",
  },
  vesting: {
    getEmployeeRetirementDetails:
      "/api/v1/Vesting/GetEmployeeRetirementDetails",
    getEmployeeVestingDetails: "/api/v1/Vesting/GetEmployeeVestingDetails",
    getEmployeeYOSDetails: "/api/v1/Vesting/GetEmployeeYOSDetails",
    postSaveVestingConfigurationForSource:
      "/api/v1/Vesting/SaveEmployeeVestingConfiguration",
    postEmployeeVestingHistoryDetails:
      "/api/v1/Vesting/PostEmployeeVestingHistoryDetails",
    GetEmployeeYOSHistoryDetails:
      "/api/v1/Vesting/GetEmployeeYOSHistoryDetails",
    runVesting: "/api/v1/Vesting/RunVesting",
    getVestingSummaryReportDetails:
      "/api/v1/Vesting/GetVestingSummaryReportDetails",
    getEmployeeVestingReportDetails:
      "/api/v1/Vesting/GetEmployeeVestingReportDetails",
  },
  transactions: {
    //loan
    getInProgressLoanDetails: "/api/v1/Loan/GetInProgressLoan",
    GetLoanByEmployeeId: "/api/v1/Loan/GetEmployeeLoan",
    getLoanById: "/api/v1/Loan/GetLoan",
    // approval count data
    getLoanAwaitingForApprovalCount:
      "/api/v1/Loan/GetLoanAwaitingForApprovalRequestCount",
    getApprovalWithdrawalCount: "/api/Distribution/GetWithdrawalCount",
    getApprovalRolloverinCount:
      "/api/RolloverIn/GetApprovalInProgressRolloverInRequestCount",

    approveLoan: "/api/v1/Loan/ApproveLoan",
    rejectLoan: "/api/v1/Loan/RejectLoan",

    //approval employeeData in card(list)
    getApprovalWithdrawalEmployee:
      "/api/Distribution/GetWithdrawalRequestForApproval",
    getApprovalLoanEmployee:
      "/api/v1/Loan/GetLoanAwaitingForApprovalRequestDetails",
    getApprovalRolloverinEmployee:
      "/api/RolloverIn/GetRolloverInRequestForApproval",

    //draft employeeData in card
    getDraftWithdrawalEmployee:
      "/api/Distribution/GetInProgressWithdrawalRequests",
    getDraftLoanEmployee: "/api/v1/transactions/",
    getDraftRolloverinEmployee:
      "/api/RolloverIn/GetRolloverInRequestInProgressList",

    // draft data count
    getDraftWithdrawalCount: "/api/Distribution/GetInProgressCount",
    getDraftLoanCount: "/api/v1/Loan/GetLoanInProgressRequestCount",
    getDraftRolloverinCount:
      "/api/RolloverIn/GetRolloverInRequestInProgressCount",

    //searchFilter for approval(post)
    getWithDrawalApprovalSearchinEmployee:
      "/api/Distribution/GetWithdrawalRequestForApproval",
    getRolloverinApprovalSearchinEmployee:
      "/api/RolloverIn/GetRolloverInRequestForApproval",
    getLoanApprovalSearchinEmployee:
      "/api/v1/Loan/GetLoanInProgressRequestDetails",

    //searchFilter for draft(post)
    getRollOverinDraftSearchinEmployee:
      "/api/RolloverIn/GetRolloverInRequestInProgressList",
    getWithdrawalsDraftSearchinEmployee:
      "/api/Distribution/GetInProgressWithdrawalRequests",

    //deletDraft
    deleteWithdrawalRequest: "/api/Distribution/DeleteWithdrawalRequest",
    deleteRollOverInRequest:
      "/api/RolloverIn/DeleteRolloverInRequestDetailsById",
    deleteLoanRequest: "/api/v1/Loan/DeleteLoan",

    getEmployeeEligiblePlanLoans: "/api/v1/Loan/GetEmployeePlanLoans",
    saveLoanRequest: "/api/v1/Loan/SaveLoan",
    submitLoanRequest: "/api/v1/Loan/SubmitLoanRequest",
    saveInProgressLoan: "/api/v1/Loan/SaveInprogressLoan",
    // submitLoanRequest: "/api/v1/Loan/SubmitLoanRequest",
    uploadLoanDocuments: "/api/v1/Loan/UploadLoanDocuments",
    loanDownloadTemplate: "/api/v1/Loan/LoanDownloadTemplate",
    getLoanSummary: "/api/v1/Loan/GetLoanSummary",
    loanRefinance: "/api/v1/Loan/SaveLoanRefinance",
    loanSuspension: "/api/v1/Loan/LoanSuspension",
    resumeSuspendedLoan: "/api/v1/Loan/ResumeSuspendedLoan",
    downloadloanRepaymentSchedule: "/api/v1/Loan/DownloadLoanRepaymentSchedule",
    downloadloanAmortizationSchedule:
      "/api/v1/Loan/DownloadLoanAmortizationSchedule",
    getAmortizationSchedule: "/api/v1/Loan/GetAmortizationSchedule",
    getRepaymentSchedule: "/api/v1/Loan/GetRepaymentSchedule",

    //loan delete

    //transfers
    getCurrentHoldings: "/api/vi/Transfer/GetCurrentHoldings",
    getInvestmentsByPlanId: "/api/v1/Plan/GetInvestmentsByPlanId",
    saveDraftOfTransferDetails: "/api/vi/Transfer/SaveDraftOfTransferDetails",
    saveTransferDetails: "/api/vi/Transfer/SaveTransferDetails",
    getTransferDetails: "/api/vi/Transfer/GetTranferDetails",
    getTransferRequestDetailsByEmpId:
      "/api/vi/Transfer/GetTransferRequestDetailsByEmpId",
    deleteTransferRequest: "/api/vi/Transfer/DeleteTransferRequest",

    //rebalance
    saveDraftOfRebalanceDetails: "/api/vi/Transfer/SaveDraftOfRebalanceDetails",
    saveRebalanceDetails: "/api/vi/Transfer/SaveRebalanceDetails",
    getRebalanceDetails: "/api/vi/Transfer/GetRebalanceDetails",
    getRebalanceRequestDetailsByEmpId:
      "/api/vi/Transfer/GetRebalanceRequestDetailsByEmpId",
    deleteRebalanceRequest: "/api/vi/Transfer/DeleteRebalanceRequest",
  },
  withdrawal: {
    getEmployeePlanWithdrawals: "/api/Distribution/GetEmployeePlanWithdrawals",
    addAddress: "/api/Distribution/AddAddress",
    addBank: "/api/Distribution/AddBank",
    saveWithdrawalRequest: "/api/Distribution/SaveWithdrawalRequest",
    getWithdrawalRequest: "/api/Distribution/GetWithdrawalRequest",
    getPeriodicPaymentCalculationDetails:
      "/api/Distribution/getPeriodicPaymentCalculationDetails",
    getStateTax: "/api/Distribution/GetStateTax",
    getWithdrawalByEmployeeId: "/api/Distribution/GetWithdrawalByEmployeeId",
    approvalWithdrawalRequest: "/api/Distribution/ApprovalWithdrawalRequest",
    uploadWithdrawalDocuments: "/api/Distribution/UploadWithdrawalDocuments",
    submitWithdrawalRequest: "/api/Distribution/SubmitWithdrawalRequest",
    getEligibleParticipantsForRMD:
      "/api/Distribution/GetEligibleParticipantsForRMD",
    getEligibleParticipantsForForceOut:
      "/api/Distribution/GetEligibleParticipantsForForceOut",
    getForcedOutParticipants: "/api/Distribution/getForcedOutParticipants",
  },
  rkaas: {
    getBalances: "/api/RKAAS/GetAccountBalance",
    getBalanceSheet: "/api/RKAAS/BalanceSheet",
    getTrailBalance: "/api/RKAAS/TrailBalance",
    getLedgers: "/api/RKAAS/Ledger",
  },
  rollOver: {
    saveRolloverInRequest: "/api/RolloverIn/SaveRolloverInRequest",
    getRolloverInRequestDetailsByEmployeeId:
      "/api/RolloverIn/GetRolloverInRequestDetailsByEmployeeId",
    deleteRolloverInRequestDetailsById:
      "/api/RolloverIn/DeleteRolloverInRequestDetailsById",
    getRolloverInRequestDetailsById:
      "/api/RolloverIn/GetRolloverInRequestDetailsById",
    saveRollOverDocuments: "/api/RolloverIn/SaveRollOverDocuments",
    approveOrRejectRolloverInRequest:
      "/api/RolloverIn/ApproveOrRejectRolloverInRequest",
  },
  fee: {
    cancelTradeByFeeId: "/api/v1/Fee/CancelTradeByFeeId",
    downloadFeeTransactionListingReport:
      "/api/v1/Fee/DownloadFeeTransactionListingReport",
    downloadFeeTransactionSummaryReport:
      "/api/v1/Fee/DownloadFeeTransactionSummaryReport",
    getFeeRunListingDetailsBySearchCriteria:
      "/api/v1/Fee/GetFeeRunListingDetailsBySearchCriteria",
    getParticipantFeeRunDetailsList:
      "/api/v1/Fee/GetParticipantFeeRunDetailsList",
    getFeeSpecificationBasedOnSearchCriteria:
      "/api/v1/Fee/GetFeeSpecificationBasedOnSearchCriteria",
    saveFeeCalculationDetails: "/api/v1/Fee/SaveFeeCalculationDetails",
    saveBasicFeeDetails: "/api/v1/Fee/SaveFeeDetails",
    getBasicFeeDetails: "api/v1/Fees/GetFeeDetails",
    getFeeDetailsById: "api/v1/Fee/GetFeeDetailsById",
    getFeeTransactionById: "/api/v1/Fee/GetFeeTransactionById",
    getFeeClassifications: "api/v1/Fee/GetFeeClassifications",
    addFeeClassification: "api/v1/Fee/AddFeeClassifications",
    validateCreateSpecificationSlider:
      "/api/v1/Fee/ValidateCreateSpecificationSlider",
    addSpecificationDetails: "/api/v1/Fee/AddSpecificationDetails",
    getFeeApplicableTo: "/api/v1/Fee/GetFeeApplicableTo",
    addFeeApplicableTo: "/api/v1/Fee/AddFeeApplicableTo",
    getFeeDetailsBySearchCriteria: "/api/v1/Fee/GetFeeDetailsBySearchCriteria",
    getFeeDetailsById: "/api/v1/Fee/GetFeeDetailsById",
    getSourceAndInvestmentList: "/api/v1/Fee/GetSourceAndInvestmentTypeList",
    getPlanListBasedOnFilter: "/api/v1/Fee/getPlanListBasedOnFilter",
    getPlanListBasedOnFilter: "/api/v1/Fee/getPlanListBasedOnFilter",
    getFeeCalculationDetailsById: "/api/v1/Fee/getFeeCalculationDetailsById",
    getFeeSpecificationDetailsById:
      "/api/v1/Fee/GetFeeSpecificationDetailsById",
    getPlanLevelFeeCollectedDetailsAfterTrade:
      "/api/v1/Fee/getPlanLevelFeeCollectedDetailsAfterTrade",
    getFeeSchedule: "/api/v1/Fee/GetFeeSchedule",
    saveSummaryDetails: "/api/v1/Fee/SaveSummaryDetails",
    getFeeSummaryDetailsById: "/api/v1/Fee/GetFeeSummaryDetailsById",
    addFeeSchedule: "/api/v1/Fee/AddFeeSchedule",
    getPlanGroupsForFee: "/api/v1/Fee/GetPlanGroupsForFee",
    getInvestmentForFee: "/api/v1/Fee/GetInvestmentForFee",
  },
  UserRegistration: {
    getRoles: "/api/UserRegistration/GetRoles",
    getPlans: "/api/UserRegistration/GetPlans",
    registerUser: "/api/UserRegistration/RegisterUser",
  },
};

export default endPoints;
